import {
    BLOCKCHAIN_SETTED,
    ETH
} from "../consts/consts";

const initialState = {
    blockchain: ETH
};

const setBlockchain = (blockchain = ETH) => {
    return {
        blockchain: blockchain
    }
};

const updateBlockchain = (state, action) => {

    if (state === undefined) {
        return initialState;
    }

    switch (action.type) {
        case BLOCKCHAIN_SETTED:
            return setBlockchain(action.blockchain);
        default:
            return state.blockchain;
    }
};

export {
    updateBlockchain
}